import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Icon = styled.div`
  height: 25px;
`;

interface ILabel {
  status: string | null;
}

export const Label = styled.div<ILabel>`
  color: ${({ status }) => {
    if (status === 'identified') return '#474D66';
    if (status === 'inventory') return '#474D66';

    return '#8F95B2';
  }};
  font-weight: 400;
  font-size: 16px;
`;
